module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "backdrop"
  }, [_c('div', {
    staticClass: "land"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    staticClass: "numbert",
    attrs: {
      "type": "text",
      "placeholder": "手机号",
      "maxlength": "11"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "Fnumber"
  }, [_vm._v("请输入正确的11位手机号!")]), _vm._v(" "), _c('div', {
    staticClass: "tuCode"
  }, [_c('input', {
    staticClass: "chart",
    attrs: {
      "type": "text",
      "placeholder": "请输入图形验证码",
      "maxlength": "6"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "chartCode"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgData
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "duanCode"
  }, [_c('input', {
    staticClass: "code",
    attrs: {
      "type": "text",
      "placeholder": "短信验证码",
      "maxlength": "6"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "codeBtn",
    attrs: {
      "disabled": _vm.btn
    }
  }, [_vm._v("获取验证码")]), _vm._v(" "), _c('p', {
    staticClass: "prompt"
  }, [_vm._v("验证码错误请重新输入")])]), _vm._v(" "), _c('div', {
    staticClass: "logn"
  }, [_vm._v("登录")]), _vm._v(" "), _c('div', {
    staticClass: "policyBox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreedToPolicy),
      expression: "agreedToPolicy"
    }],
    staticClass: "agreedToPolicy",
    attrs: {
      "type": "checkbox",
      "id": "agreeToPolicy"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreedToPolicy) ? _vm._i(_vm.agreedToPolicy, null) > -1 : (_vm.agreedToPolicy)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.agreedToPolicy,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agreedToPolicy = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.agreedToPolicy = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agreedToPolicy = $$c
        }
      }
    }
  }), _vm._v("\n       同意"), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://nbp-activity-bucket.noahgroup.com/fed/20260403/%E4%BB%A5%E8%AF%BA%E6%95%99%E8%82%B2%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96v202501.pdf"
    }
  }, [_vm._v("《以诺教育隐私政策》")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Ierror"
  }, [_c('span', {
    staticClass: "cha"
  }, [_vm._v("×")]), _vm._v(" "), _c('h1', {
    staticClass: "LHeader"
  }, [_vm._v("欢迎登录以诺")]), _vm._v(" "), _c('p', {
    staticClass: "LWen"
  }, [_vm._v("如果您第一次登录，我们将为您创建以诺账户")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6204667b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/land/land.vue
// module id = 550
// module chunks = 1